import React from 'react';

import { VipTierLabel } from '../../utils/constants';

// Tier accents mirror the Promo.js qualifying-volume callout theme and the
// player-facing /vip page: Big Degen = blue, VIP = crimson, VVIP = purple
// (Admin's art pack, 2026-08-19 — Big Degen moved off gold). Darkened from the
// dapp's #4a7dff / #e05555 so white pill text stays readable on this light UI.
// Anything else (e.g. LEADERBOARD rows, which carry a non-rung tier) falls back
// to neutral — tier is an opaque string on the lookup read path, never an enum.
const VIP_TIER_ACCENT = {
  BD: '#2b5fd9',
  VIP: '#c0392b',
  VVIP: '#4338ca',
};

export const TierBadge = ({ tier }) => (
  <span
    className="badge rounded-pill"
    style={{
      background: VIP_TIER_ACCENT[tier] ?? '#495057',
      color: '#fff',
      fontWeight: 600,
      letterSpacing: '0.02em',
    }}
  >
    {VipTierLabel[tier] ?? tier}
  </span>
);

export const KindBadge = ({ kind }) =>
  kind === 'LEADERBOARD' ? (
    <span className="badge bg-info text-dark">Top-3</span>
  ) : (
    <span className="badge bg-secondary">Tier</span>
  );

export const CycleStatusBadge = ({ status }) => {
  const bg =
    {
      FINALIZED: 'bg-success',
      FINALIZING: 'bg-warning text-dark',
      DRAFT: 'bg-secondary',
      HALTED: 'bg-danger',
    }[status] ?? 'bg-secondary';
  return <span className={`badge ${bg}`}>{status}</span>;
};

export const DistributionStateBadge = ({ state }) => {
  const bg =
    {
      READY: 'bg-primary',
      CLAIMED: 'bg-success',
      ERROR: 'bg-danger',
    }[state] ?? 'bg-secondary';
  return <span className={`badge ${bg}`}>{state}</span>;
};

export const PLACE_MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };
